import Main from './ExternalPlatformIntegrationsMain'

export default {
  Main,
}
